import React from 'react'
import PropTypes from 'prop-types'
import Button from 'common/buttons'

const BtnCancel = ({ action }) => <Button action={action}>cancel</Button>

BtnCancel.propTypes = { action: PropTypes.func.isRequired }

export default BtnCancel
